<template>
<el-menu
  active-text-color="#3e10d5"
  @open="fetchAssignedApplications"
  class='el-menu-vertical-admin'
  :unique-opened=true
  :default-active="active"
>
  <div>Οι αιτήσεις μου από
    <el-submenu
      v-for="(submenu, key) in assignedApps"
      :key="submenu[0].id"
      :index="submenu[0].id"
    >
      <template slot="title">
        <span>{{translate(key)}}</span> <el-badge :value="numberOfApps[key]"></el-badge>
      </template>
      <el-menu-item v-for="app in mainApps" :key="app.id" :value="app.id" class="list-group-item"
        @click="toggleApplication (app)" :index='roleIndexId (app.id)' style="padding: 0px 5px;">
        <div class="text item" v-if="showPopover">
          <el-popover trigger="hover" placement="right">
            <div v-if="activeLane == 'presidentW_Prechecker'">
              Αρ. αίτησης: {{app.id}}
              <br>Αρ. πρωτ.: {{app.protocol}}
              <br>Ημ/νια πρωτοκόλλου: {{app.protocolDate.substring(0, 10)}}
              <br>Ακαδ. περιοχή: {{app.academicArea}}
              <br>Ον/μο υπαλλήλου προελέγχου: {{app.precheckerSurname}} {{app.precheckerName}}
            </div>
            <div v-if="activeLane == 'viewerW_Proponent'">
               Αρ. αίτησης: {{app.id}}
              <br>Αρ. πρωτ.: {{app.protocol}}
              <br>Ημ/νια πρωτοκόλλου: {{app.protocolDate.substring(0, 10)}}
              <br>Ακαδ. περιοχή: {{app.academicArea}}
              <br>Ον/μο εισηγητή: {{app.proponentSurname}} {{app.proponentName}}
            </div>
            <div v-if="activeLane == 'viewerW_Board'">
               Αρ. αίτησης: {{app.id}}
              <br>Αρ. πρωτ.: {{app.protocol}}
              <br>Ημ/νια πρωτοκόλλου: {{app.protocolDate.substring(0, 10)}}
              <br>Ακαδ. περιοχή: {{app.academicArea}}
              <br>Εκτ.Επιτροπή: {{app.executiveBoard}}
            </div>
            <div v-if="activeLane == 'viewerW_Vice'">
               Αρ. αίτησης: {{app.id}}
              <br>Αρ. πρωτ.: {{app.protocol}}
              <br>Ημ/νια πρωτοκόλλου: {{app.protocolDate.substring(0, 10)}}
              <br>Ακαδ. περιοχή: {{app.academicArea}}
            </div>
            <div v-if="activeLane == 'presidentW_PrintDecision'">
               Αρ. αίτησης: {{app.id}}
              <br>Αρ. πρωτ.: {{app.protocol}}
              <br>Ημ/νια πρωτοκόλλου: {{app.protocolDate.substring(0, 10)}}
              <br>Ακαδ. περιοχή: {{app.academicArea}}
            </div>
            <div v-if="['printdecisionw_', 'precheckerW_', 'precheckerCompensatoryW_'].includes(activeLane)">
              Αρ. αίτησης: {{app.id}}
              <br>Αρ. πρωτ.: {{app.protocol? app.protocol : 'Θα οριστεί με την ολοκλήρωση του προελέγχου'}} <br>
              Ημ/νια πρωτοκόλλου: {{app.protocolDate ? app.protocolDate.substring(0, 10) : 'Θα οριστεί με την ολοκλήρωση του προελέγχου'}}
            </div>
             <div v-if="['proponentW_President', 'proponentW_Prechecker', 'proponentW_Board', 'proponentW_Admin', 'presidentW_Consultant',
              'presidentW_Viewer', 'presidentW_AcademicDirector', 'presidentW_AcademicDirector_Reappraisal', 'presidentW_ReappraisalBoard',
              'presidentW_AcademicDirector_fromProponent'].includes(activeLane)"
            >
              Αρ. αίτησης: {{app.id}}
              <br>Αρ. πρωτ.: {{app.protocol}}
              <br>Ημ/νια πρωτοκόλλου: {{app.protocolDate.substring(0, 10)}}
              <br>Ακαδ. περιοχή: {{app.academicArea}}
            </div>
            <div v-if="['consultantW_proponent', 'consultantw_President', 'viewerW_President', 'academicDirectorW_President',
              'proponentW_ReappraisalBoard', 'academicDirectorW_ReappraisalBoard'].includes(activeLane)">
               Id αίτησης: {{app.id}}
              <br>Αρ. πρωτ.: {{app.protocol}}
              <br>Ημ/νια πρωτοκόλλου: {{app.protocolDate.substring(0, 10)}}
            </div>
            <div v-if="activeLane === 'reappraisalBoardW_Vice'">
               Id αίτησης: {{app.id}}
              <br>Ημ/νια πρωτοκόλλου: {{app.protocolDate.substring(0, 10)}}
              <br>Επιτροπή επανεξ:{{app.reappraisalBoardName}}
            </div>
            <div v-if="activeLane === 'reappraisalBoardW_President'">
               Id αίτησης: {{app.id}}
              <br>Ημ/νια πρωτοκόλλου: {{app.protocolDate.substring(0, 10)}}
              <br>Επιτροπή επανεξ:{{app.reappraisalBoardName}}
            </div>
             <div v-if="activeLane == 'academicDirectorW_Proponent'">
               Αρ. αίτησης: {{app.id}}
              <br>Αρ. πρωτ.: {{app.protocol}}
              <br>Ημ/νια πρωτοκόλλου: {{app.protocolDate.substring(0, 10)}}
              <br>Ακαδ. περιοχή: {{app.academicArea}}
            </div>
             <span slot="reference">
              <el-button circle :style="calcStyle(app)">{{calcDegreeType(app.degreeType, app.applicationType)}}</el-button>
              <!-- η ουρά του προελέγχου ταξινομείται με και εμφανίζει το protocolDate ενώ οι ουρές των υπόλοιπων ρόλων με το dateCompleted/ημερ.ολοκληρωσης προελέγχου -->
              {{app.dateCompleted ? app.dateCompleted.substring(0, 10) : app.protocolDate ? app.protocolDate.substring(0,10) : app.id}}
              {{app.surname.substring(0, 18)}}
              {{app.name.substring(0, 1)}}.
            </span>
          </el-popover>
        </div>
      </el-menu-item>
    </el-submenu>
  </div>
  <el-submenu index=0 key=0 v-if='rolesToShow'>
    <template slot="title">
      <span>Αναμονή</span> <el-badge :value="numberOfStashedApps"></el-badge>
    </template>
    <el-menu-item v-for="app in stashedApps" :key="app.id" :value="app.id" class="list-group-item"
      @click="toggleApplication (app)" :index='roleIndexId (app.id)' style="padding: 0px 5px;">
        <div class="text item">
          <span>
            <el-button circle :style="calcStyle(app)">{{calcDegreeType(app.degreeType, app.applicationType)}}</el-button>
            {{app.dateCompleted ? app.dateCompleted.substring(0, 10) : app.protocolDate ? app.protocolDate.substring(0,10) : app.id}}
            {{app.surname.substring(0, 18)}}
            {{app.name.substring(0, 1)}}.
          </span>
        </div>
    </el-menu-item>
  </el-submenu>
  <el-menu-item index='1000' @click="toggleSearch" v-if='activeRole != "AcademicConsultant" && activeRole != "Auditor" && activeRole != "SpecialReappraisalBoardMember"'>
    <template slot="title">
      <span>Αναζήτηση Αιτήσεων</span>
    </template>
  </el-menu-item>
    <el-menu-item index='1001' @click="toggleUniSearch" v-if='activeRole != "AcademicConsultant" && activeRole != "Auditor" && activeRole != "SpecialReappraisalBoardMember"'>
    <template slot="title">
      <span>Αναζήτηση Ιδρυμάτων</span>
    </template>
  </el-menu-item>
  <el-menu-item index="1002" @click="addUniversity" v-if='activeRole == "SpecialProponent"'>
    <span>Διαχειριστικό Ιδρυμάτων</span>
  </el-menu-item>
  <el-menu-item index="1003" @click="toggleConsultantsList" v-if='activeRole == "President"'>
    <span>Στατιστικά αξιολογητών</span>
  </el-menu-item>
  <el-menu-item index="1004" @click="togglePhdRegistration" v-if='activeRole == "PhdRegistry"'>
    <span>Καταχώριση Διδακτορικών στο ΕΑΔΔ</span>
  </el-menu-item>
</el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import dictionaryForMenu from '../../store/dictionaryForMenu'

export default {
  components: {
    dictionaryForMenu
  },
  props: ['assignedApplications', 'assignedApps'],
  data () {
    return {
      numberOfStashedApps: '',
      numberOfApps: {
        proponentW_President: '',
        proponentW_Prechecker: '',
        proponentW_Board: '',
        proponentW_Admin: '',
        precheckerW_: '',
        precheckerCompensatoryW_: '',
        printdecisionw_: '',
        presidentW_Prechecker: '',
        presidentW_Consultant: '',
        presidentW_PrintDecision: '',
        viewerW_Proponent: '',
        viewerW_Board: '',
        viewerW_Vice: '',
        reappraisalBoardW_Vice: '',
        reappraisalBoardW_President: ''
      },
      editable: true,
      activeLane: '',
      assignedAppsAll: [],
      active: '0',
      appInfo: ''
    }
  },
  mounted () {
    // console.clear()
    console.log('assignedApps:', this.assignedApps)
  },
  methods: {
    addUniversity () {
      this.$emit('addUniversity')
    },
    calcDegreeType (type, appType) {
      if (appType === 'ΕΠΑΝΕΞΕΤΑΣΗΣ ΑΙΤΗΜΑΤΟΣ ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ ΣΠΟΥΔΩΝ') {
        return 'Ε'
      } else if (appType === 'ΕΚΔΟΣΗΣ ΠΡΑΞΗΣ ΜΕΤΑ ΑΠΟ ΕΞΕΤΑΣΕΙΣ') {
        return 'Τ'
      } else {
        if (type === 'bachelor') {
          return 'Β'
        } else if (type === 'master') {
          return 'M'
        } else if (type === 'phd') {
          return 'Δ'
        } else {
          return ''
        }
      }
    },
    calcStyle (app) {
      let color = null
      if (this.activeRole === 'PreChecker' || this.activeRole === 'PrintDecision') {
        color = app.color
      } else if (this.activeRole === 'SpecialProponent' || this.activeRole === 'President') {
        if (app.comment && app.comment.judgment) {
          color = app.comment.judgment.color
        }
      }
      return color
        ? `background-color: ${color}; border-radius: 20px; overflow-wrap: break-word; padding: 5px;`
        : `background-color: #7fa3bb; border-radius: 20px; overflow-wrap: break-word; padding: 5px;`
    },
    translate (term) {
      return dictionaryForMenu[term] ? dictionaryForMenu[term] : ''
    },
    fetchAssignedApplications (laneFrom, path) {
      console.log('laneFrom:', laneFrom)
      console.log('path:', path)
      this.active = '0'
      this.activeLane = Object.keys(this.assignedApps)[laneFrom - 1]
      console.log('activeLane:', this.activeLane)
      if (this.activeLane === undefined) {
      } else if (this.activeLane !== 'personalQueue') {
        this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
      }
    },
    toggleSearch () {
      this.$store.dispatch('SHOW_HIDE_APPSEARCH')
    },
    toggleUniSearch () {
      this.$store.dispatch('SHOW_HIDE_UNISEARCH')
    },
    toggleConsultantsList () {
      this.$store.dispatch('SHOW_HIDE_CONSULTANTS_LIST')
    },
    togglePhdRegistration () {
      this.$store.dispatch('SHOW_HIDE_PHD_REGISTRATION')
    },
    toggleStats () {
      this.$store.dispatch('SHOW_HIDE_STATS')
    },
    toggleApplication (app) {
      this.$store.dispatch('LOAD_WORKING_APPLICATION', app.id)
    },
    roleIndexId (roleId) {
      return `2-${roleId + 1}`
    }
  },
  computed: {
    // calcLane () {
    //   return ![
    //     'presidentW_Prechecker',
    //     'viewerW_Proponent',
    //     'viewerW_Board',
    //     'viewerW_Vice',
    //     'presidentW_PrintDecision',
    //     'auditorW_',
    //     'proponentW_President',
    //     'proponentW_Board',
    //     'proponentW_Admin'
    //   ].includes(this.activeLane)
    // },
    showPopover () {
      return ![
        'auditor'
      ].includes(this.activeLane)
    },
    rolesToShow () {
      return [
        'PreChecker',
        'SpecialProponent',
        'PrintDecision',
        'President'
      ].includes(this.activeRole)
    },
    mainApps () {
      console.log('assignedApplications:', this.assignedApplications)
      if (this.activeRole === 'PreChecker' || this.activeRole === 'PrintDecision') {
        return this.assignedApplications.filter(app => !app.queue)
      } else if (this.activeRole === 'SpecialProponent' || this.activeRole === 'President') {
        return this.assignedApplications.filter(app => !app.comment || !app.comment.judgment || !app.comment.judgment.queue)
      }
      return this.assignedApplications
    },
    stashedApps () {
      if (this.activeRole === 'PreChecker' || this.activeRole === 'PrintDecision') {
        return this.assignedApplications.filter(app => app.queue)
      } else if (this.activeRole === 'SpecialProponent' || 'President') {
        return this.assignedApplications.filter(app => app.comment && app.comment.judgment && app.comment.judgment.queue)
      }
      return this.assignedApplications
    },
    ...mapGetters(['activeRole'])
  },
  watch: {
    assignedApplications: function (newData, oldData) {
      console.log('newData:', newData)
      // if (this.activeLane === 'precheckerW_' || this.activeLane === 'printdecisionw_') {
      if (['precheckerW_', 'printdecisionw_', 'precheckerCompensatoryW_'].includes(this.activeLane)) {
        this.numberOfApps[this.activeLane] = newData
          .filter(app => app.queue === false || app.queue === null).length
        this.numberOfStashedApps = newData
          .filter(app => app.queue === true).length
      } else if (
        [
          'proponentW_President',
          'proponentW_Prechecker',
          'proponentW_Board',
          'proponentW_Admin',
          'presidentW_Prechecker',
          'presidentW_Viewer',
          'presidentW_PrintDecision',
          'presidentW_Consultant',
          'presidentW_AcademicDirector_Reappraisal',
          'presidentW_AcademicDirector'
        ].includes(this.activeLane)) {
        this.numberOfApps[this.activeLane] = newData
          .filter(
            app => app.comment.judgment.queue === false ||
            app.comment.judgment.queue === null
          ).length
        this.numberOfStashedApps = newData
          .filter(app => app.comment.judgment.queue === true).length
      } else if (
        [
          'viewerW_Proponent',
          'viewerW_Board',
          'viewerW_Vice'
        ].includes(this.activeLane)) {
        if (this.activeRole === 'President') {
          this.numberOfApps[this.activeLane] = newData
            .filter(
              app => app.comment.judgment.queue === false ||
              app.comment.judgment.queue === null
            ).length
          this.numberOfStashedApps = newData
            .filter(app => app.comment.judgment.queue === true).length
        } else {
          this.numberOfApps[this.activeLane] = newData.length
        }
      } else {
        this.numberOfApps[this.activeLane] = newData.length
      }
    }
  }
  // watch assigned as they come with a local variable pointing to the active menu and add them to
  // the object containing all the assigned applications
  // Use a translate method to translate the queues to the greek names Προέλεγχος, Ειδικός...
}
</script>

<style lang="scss">
// .box-card {
//   width: 280px;
// }
li.el-menu-item.list-group-item {
  padding-left: 5px;
}
.el-submenu {
  border-radius: 20px;
  overflow-wrap: break-word;
  border: 2px solid #7fa3bb;
  padding: 5px;
  &__title:hover {
    background-color: "#b3c0d1";
  }
}
.el-menu-vertical-admin {
  margin: 5px;
  word-wrap: break-word;
  border-radius: 0px 20px;
  border: 2px solid #7fa3bb;
  padding: 10px;
}
.el-card__body {
  padding: 2px;
  // height: 40px;
}
/*.el-input--small .el-input__inner {*/
  /*width: 150px*/
/*}*/
// .el-card {
//   margin: 5px;
// }
.el-card__header {
  padding: 8px 20px;
}
.list-group-item {
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
  position: relative;
  display: block;
  margin-bottom: 0px;
  border: 1px solid rgba(0,0,0,.125);
  border-radius: 4px
}
.list-group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
ul, menu, dir {
  display: block;
  list-style-type: disc;
  -webkit-margin-after: 1em;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ApplicationsLane.vue